var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVistaraL(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#212121;}\n\t.st1{fill:#E3F1FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -2895.4,
    y: -253.3,
    className: "st0",
    width: 333.8,
    height: 209.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "434.3,376.1 428.7,341.5 443.3,432.5 442.5,427 492.2,373.6 497.4,405.6 484,322.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "514.3,510.9 464.6,564.4 457.6,521.2 507.4,467.7 510.8,489.2 499.2,416.7 449.4,470.2 472.8,615.4  522.5,561.9 529.5,605.1 479.7,658.6 479.2,655.2 480.9,665.9 537.9,657.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "477.1,279.4 476.7,277 419.8,285.8 427.3,332.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "652.6,335.2 660.2,288.2 603.3,279.3 602.9,281.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "645.6,378.4 595.9,324.9 582.3,409 587.7,375.8 637.4,429.4 651.8,340.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "599.8,660.9 550.1,607.4 557.1,564.2 606.8,617.7 615.1,566.8 565.4,513.2 541.7,659.3 598.7,668.2  600.7,655.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "568.8,491.9 572.4,470 622.1,523.6 618,549.1 630.4,472.6 580.7,419  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M435.6,767.5l13.2-43.9h13.4L441.9,782h-12.6l-20.3-58.4h13.4L435.6,767.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M466.9,727.4c0-1.7,0.6-3.2,1.7-4.3c1.2-1.1,2.7-1.7,4.8-1.7c2,0,3.6,0.6,4.7,1.7c1.2,1.1,1.8,2.6,1.8,4.3 c0,1.8-0.6,3.2-1.8,4.3c-1.2,1.1-2.8,1.7-4.7,1.7c-2,0-3.5-0.6-4.7-1.7C467.5,730.6,466.9,729.1,466.9,727.4z M479.2,782h-11.6 v-43.4h11.6V782z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512.3,770c0-1.4-0.7-2.5-2.1-3.3c-1.4-0.8-3.7-1.5-6.8-2.2c-10.3-2.2-15.5-6.6-15.5-13.2 c0-3.9,1.6-7.1,4.8-9.6s7.4-3.9,12.5-3.9c5.5,0,9.9,1.3,13.2,3.9c3.3,2.6,5,6,5,10.1h-11.6c0-1.7-0.5-3-1.6-4.1 c-1.1-1.1-2.7-1.6-5-1.6c-2,0-3.5,0.4-4.5,1.3c-1.1,0.9-1.6,2-1.6,3.4c0,1.3,0.6,2.3,1.8,3.1c1.2,0.8,3.3,1.5,6.2,2 c2.9,0.6,5.3,1.2,7.3,1.9c6.1,2.2,9.2,6.1,9.2,11.7c0,4-1.7,7.2-5.1,9.6c-3.4,2.4-7.8,3.7-13.2,3.7c-3.6,0-6.9-0.6-9.7-1.9 c-2.8-1.3-5-3.1-6.6-5.3c-1.6-2.3-2.4-4.7-2.4-7.3h11c0.1,2.1,0.9,3.6,2.3,4.7s3.3,1.6,5.7,1.6c2.2,0,3.9-0.4,5-1.3 S512.3,771.4,512.3,770z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.9,727.9v10.7h7.4v8.5h-7.4v21.7c0,1.6,0.3,2.8,0.9,3.5c0.6,0.7,1.8,1,3.5,1c1.3,0,2.4-0.1,3.4-0.3v8.8 c-2.3,0.7-4.6,1-7,1c-8.1,0-12.3-4.1-12.4-12.3v-23.4H527v-8.5h6.3v-10.7H544.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M583.9,782c-0.5-1-0.9-2.3-1.2-3.9c-2.8,3.1-6.5,4.7-11,4.7c-4.3,0-7.8-1.2-10.6-3.7s-4.2-5.6-4.2-9.3 c0-4.6,1.7-8.1,5.1-10.6c3.4-2.5,8.3-3.7,14.8-3.7h5.3V753c0-2-0.5-3.6-1.5-4.8c-1-1.2-2.7-1.8-4.9-1.8c-2,0-3.5,0.5-4.6,1.4 c-1.1,0.9-1.7,2.2-1.7,3.9H558c0-2.5,0.8-4.8,2.3-7c1.6-2.1,3.7-3.8,6.6-5c2.8-1.2,6-1.8,9.5-1.8c5.3,0,9.6,1.3,12.7,4 c3.1,2.7,4.7,6.5,4.7,11.3V772c0,4.1,0.6,7.2,1.7,9.3v0.7H583.9z M574.3,774c1.7,0,3.3-0.4,4.7-1.1s2.5-1.8,3.2-3.1v-7.5H578 c-5.8,0-8.9,2-9.3,6l0,0.7c0,1.4,0.5,2.6,1.5,3.6C571.2,773.5,572.6,774,574.3,774z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M627.2,749.5c-1.6-0.2-3-0.3-4.2-0.3c-4.4,0-7.3,1.5-8.6,4.5V782h-11.6v-43.4h11l0.3,5.2c2.3-4,5.6-6,9.7-6 c1.3,0,2.5,0.2,3.6,0.5L627.2,749.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M656.8,782c-0.5-1-0.9-2.3-1.2-3.9c-2.8,3.1-6.5,4.7-11,4.7c-4.3,0-7.8-1.2-10.6-3.7s-4.2-5.6-4.2-9.3 c0-4.6,1.7-8.1,5.1-10.6c3.4-2.5,8.3-3.7,14.8-3.7h5.3V753c0-2-0.5-3.6-1.5-4.8c-1-1.2-2.7-1.8-4.9-1.8c-2,0-3.5,0.5-4.6,1.4 c-1.1,0.9-1.7,2.2-1.7,3.9h-11.6c0-2.5,0.8-4.8,2.3-7c1.6-2.1,3.7-3.8,6.6-5c2.8-1.2,6-1.8,9.5-1.8c5.3,0,9.6,1.3,12.7,4 c3.1,2.7,4.7,6.5,4.7,11.3V772c0,4.1,0.6,7.2,1.7,9.3v0.7H656.8z M647.2,774c1.7,0,3.3-0.4,4.7-1.1s2.5-1.8,3.2-3.1v-7.5h-4.3 c-5.8,0-8.9,2-9.3,6l0,0.7c0,1.4,0.5,2.6,1.5,3.6C644,773.5,645.4,774,647.2,774z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.8,856.8h-23.1v23.9h-12v-58.4h38v9.7h-26V847h23.1V856.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M465,881.4c-6.4,0-11.5-2-15.5-5.9c-4-3.9-6-9.1-6-15.6v-1.1c0-4.4,0.8-8.3,2.5-11.7c1.7-3.4,4.1-6.1,7.2-7.9 c3.1-1.9,6.6-2.8,10.6-2.8c5.9,0,10.6,1.9,14,5.6c3.4,3.7,5.1,9.1,5.1,15.9v4.7h-27.6c0.4,2.8,1.5,5.1,3.4,6.8 c1.9,1.7,4.3,2.6,7.2,2.6c4.5,0,8-1.6,10.5-4.9l5.7,6.4c-1.7,2.5-4.1,4.4-7.1,5.8C471.9,880.7,468.6,881.4,465,881.4z  M463.7,845.8c-2.3,0-4.2,0.8-5.6,2.3c-1.4,1.6-2.3,3.8-2.7,6.7h16.1v-0.9c-0.1-2.6-0.7-4.6-2.1-6 C468.1,846.5,466.2,845.8,463.7,845.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M513,868.6c0-1.4-0.7-2.5-2.1-3.3c-1.4-0.8-3.7-1.5-6.8-2.2c-10.3-2.2-15.5-6.6-15.5-13.2 c0-3.9,1.6-7.1,4.8-9.6s7.4-3.9,12.5-3.9c5.5,0,9.9,1.3,13.2,3.9c3.3,2.6,5,6,5,10.1h-11.6c0-1.7-0.5-3-1.6-4.1 c-1.1-1.1-2.7-1.6-5-1.6c-2,0-3.5,0.4-4.5,1.3c-1.1,0.9-1.6,2-1.6,3.4c0,1.3,0.6,2.3,1.8,3.1c1.2,0.8,3.3,1.5,6.2,2 c2.9,0.6,5.3,1.2,7.3,1.9c6.1,2.2,9.2,6.1,9.2,11.7c0,4-1.7,7.2-5.1,9.6c-3.4,2.4-7.8,3.7-13.2,3.7c-3.6,0-6.9-0.6-9.7-1.9 c-2.8-1.3-5-3.1-6.6-5.3c-1.6-2.3-2.4-4.7-2.4-7.3h11c0.1,2.1,0.9,3.6,2.3,4.7s3.3,1.6,5.7,1.6c2.2,0,3.9-0.4,5-1.3 S513,870,513,868.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M545.6,826.5v10.7h7.4v8.5h-7.4v21.7c0,1.6,0.3,2.8,0.9,3.5c0.6,0.7,1.8,1,3.5,1c1.3,0,2.4-0.1,3.4-0.3v8.8 c-2.3,0.7-4.6,1-7,1c-8.1,0-12.3-4.1-12.4-12.3v-23.4h-6.3v-8.5h6.3v-10.7H545.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M559.4,826c0-1.7,0.6-3.2,1.7-4.3c1.2-1.1,2.7-1.7,4.8-1.7c2,0,3.6,0.6,4.7,1.7c1.2,1.1,1.8,2.6,1.8,4.3 c0,1.8-0.6,3.2-1.8,4.3c-1.2,1.1-2.8,1.7-4.7,1.7c-2,0-3.5-0.6-4.7-1.7C560,829.2,559.4,827.7,559.4,826z M571.7,880.6h-11.6 v-43.4h11.6V880.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M597.5,866.5l8.1-29.2h12.1l-14.6,43.4H592l-14.6-43.4h12.1L597.5,866.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M647.3,880.6c-0.5-1-0.9-2.3-1.2-3.9c-2.8,3.1-6.5,4.7-11,4.7c-4.3,0-7.8-1.2-10.6-3.7s-4.2-5.6-4.2-9.3 c0-4.6,1.7-8.1,5.1-10.6c3.4-2.5,8.3-3.7,14.8-3.7h5.3v-2.5c0-2-0.5-3.6-1.5-4.8c-1-1.2-2.7-1.8-4.9-1.8c-2,0-3.5,0.5-4.6,1.4 c-1.1,0.9-1.7,2.2-1.7,3.9h-11.6c0-2.5,0.8-4.8,2.3-7c1.6-2.1,3.7-3.8,6.6-5c2.8-1.2,6-1.8,9.5-1.8c5.3,0,9.6,1.3,12.7,4 c3.1,2.7,4.7,6.5,4.7,11.3v18.8c0,4.1,0.6,7.2,1.7,9.3v0.7H647.3z M637.8,872.6c1.7,0,3.3-0.4,4.7-1.1s2.5-1.8,3.2-3.1v-7.5h-4.3 c-5.8,0-8.9,2-9.3,6l0,0.7c0,1.4,0.5,2.6,1.5,3.6C634.6,872.1,636,872.6,637.8,872.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M678.5,880.6h-11.6V819h11.6V880.6z"
  })))), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-2380.4,482.4 -2385.5,450.8 -2372.2,533.9 -2372.9,528.9 -2327.5,480.1 -2322.8,509.3 -2335,433.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-2307.4,605.5 -2352.8,654.3 -2359.1,614.9 -2313.7,566.1 -2310.6,585.6 -2321.2,519.5  -2366.6,568.3 -2345.3,700.8 -2299.9,652 -2293.5,691.4 -2338.9,740.2 -2339.5,737.1 -2337.9,746.9 -2285.9,738.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-2341.4,394.2 -2341.7,392 -2393.7,400.1 -2386.8,443  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-2181.2,445.1 -2174.2,402.2 -2226.2,394.1 -2226.5,396.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-2187.6,484.5 -2232.9,435.7 -2245.4,512.5 -2240.5,482.2 -2195.1,531.1 -2181.9,449.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-2229.3,742.3 -2274.7,693.5 -2268.3,654.1 -2223,702.9 -2215.4,656.4 -2260.8,607.5 -2282.4,740.9  -2230.4,749 -2228.5,737.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-2257.6,588.1 -2254.4,568.1 -2209,617 -2212.8,640.3 -2201.5,570.5 -2246.8,521.6  "
  })))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -2116.3076 609.5547)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st0",
    style: {
      fontFamily: "'Roboto-Bold'",
      fontSize: "92.7575px"
    }
  }, "Vistara "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 111.3,
    className: "st0",
    style: {
      fontFamily: "'Roboto-Bold'",
      fontSize: "92.7575px"
    }
  }, "Festival"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVistaraL);
export default __webpack_public_path__ + "static/media/vistaraL.28346d34c433f452aabe729443e11aa3.svg";
export { ForwardRef as ReactComponent };